// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
const firebaseConfig = {
  apiKey: "AIzaSyARG4bdw4rM8S_OD9yWa_iCOki_R3rQh7o",
  authDomain: "predictorz-74289.firebaseapp.com",
  projectId: "predictorz-74289",
  storageBucket: "predictorz-74289.firebasestorage.app",
  messagingSenderId: "326576383673",
  appId: "1:326576383673:web:b2ab629765c75ddc0e1d68",
  measurementId: "G-ELBQ2DT10F"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

